import { api } from '@/main'

const defaultState = {
  current_record_id: null,
  email: null,
  first_name: null,
  last_name: null,
  gender: null,
  phone_number: null,
  id: null
}

export default {
  namespaced: true,
  state: {
    ...defaultState
  },
  mutations: {
    RESET_MODULE: state => {
      Object.keys(state).forEach(key => {
        state[key] = defaultState[key]
      })
    },
    SET_CUSTOMER: (state, customer) => {
      Object.assign(state, customer)
    }
  },
  actions: {
    resetModule(store) {
      store.commit('RESET_MODULE')
    },
    async register(store, data) {
      return await api.customer.register(data)
    },
    async confirm(store, data) {
      const r = await api.customer.confirmUser(data)

      if (r) {
        await store.dispatch('auth/setAuthFromToken', { ...r }, { root: true })

        delete r.token

        store.commit('SET_CUSTOMER', r)
      }
    },
    async getCustomer(store, data) {
      const r = await api.customer.getUser()

      // Get current record if one is given through the login payload
      if (r && r.current_record_id) {
        try {
          await store.dispatch(
            'records/getRecord',
            { id: r.current_record_id },
            {
              root: true
            }
          )
        } catch (error) {
          console.warn(`Current record id "${r.current_record_id}" not found`)
        }
      }

      store.commit('SET_CUSTOMER', r)
    },
    async update(store, data) {
      try {
        return await api.customer.updateUser(data)
      } catch (error) {
        console.warn(error)
      }
    },
    async resetPassword(store, data) {
      return await api.customer.resetPassword(data)
    },
    /**
     * Ask for a forgot password email.
     *
     * @param {*} data  { email }
     */
    async forgotPassword(store, data) {
      return await api.customer.forgotPassword(data)
    }
  }
}
